import { Alert, Box, CircularProgress, Typography } from "@mui/material";
import { type TaskerTask } from "../../../services/taskerService";
import { usePriorSteps } from "./priorSteps";
import { VendorApplicationSummary } from "./VendorApplicationSummary";

type Props = { task: TaskerTask };

export function SubmittedVendorDataPanel({ task }: Props) {
  const priorStepsQuery = usePriorSteps(task.id, task.task_type_id);

  if (priorStepsQuery.isPending) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", py: 6 }}>
        <CircularProgress size={24} />
      </Box>
    );
  }

  if (priorStepsQuery.isError) {
    return (
      <Box sx={{ p: 3 }}>
        <Alert severity="error">
          Couldn&apos;t load the vendor&apos;s submitted data. Refresh to retry.
        </Alert>
      </Box>
    );
  }

  const priorSteps = priorStepsQuery.data;
  if (!priorSteps || priorSteps.length === 0) {
    return (
      <Box sx={{ p: 3 }}>
        <Typography variant="body2" sx={{ color: "text.secondary" }}>
          Vendor has not submitted any data yet.
        </Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ p: 3 }}>
      <Typography
        sx={{
          fontSize: 11,
          fontWeight: 700,
          color: "text.secondary",
          letterSpacing: 0.6,
          textTransform: "uppercase",
          mb: 2,
        }}
      >
        Submitted Vendor Data · Read Only
      </Typography>
      <VendorApplicationSummary priorSteps={priorSteps} authMode="reviewer" />
    </Box>
  );
}
